import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { attestationService } from '../../services/attestationService';

export const AttestationBanner: React.FC = () => {
  const { user } = useAuth();
  const [pendingCount, setPendingCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;

    const loadPendingCount = async () => {
      try {
        const pending = await attestationService.getPendingForUser(user.uid);
        setPendingCount(pending.length);
      } catch (error) {
        console.error('Error loading pending attestations:', error);
      } finally {
        setLoading(false);
      }
    };

    loadPendingCount();

    // Refresh every 30 seconds
    const interval = setInterval(loadPendingCount, 30000);
    return () => clearInterval(interval);
  }, [user]);

  if (loading || pendingCount === 0) {
    return null;
  }

  return (
    <Link
      to="/attestations"
      className="block"
      style={{ background: '#1a1708' }}
    >
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between gap-4">
        <div>
          <p className="text-amber-400 font-medium">
            You have {pendingCount} pending attestation{pendingCount !== 1 ? 's' : ''}
          </p>
          <p className="text-sm text-amber-600">
            Please review and acknowledge recent training materials
          </p>
        </div>
        <span className="text-amber-400 font-semibold">{pendingCount}</span>
      </div>
    </Link>
  );
};
